import { Component } from '@angular/core';
import { IntroThreeComponent } from './intro-three.component';

@Component({
  selector: 'eid-intro-three-mobile',
  templateUrl: './intro-three.mobile.component.html',
  styleUrls: ['./intro-three.mobile.component.scss']
})
export class IntroThreeMobileComponent extends IntroThreeComponent {}
